import { createSlice } from "@reduxjs/toolkit";

const initialState={
    color:'black'
}

export const colorSlice = createSlice({
    name:"colorslice",
    initialState,
    reducers:{
        change:(state, action)=>{
            state.color=action.payload
        }
    }
})

export const {change} = colorSlice.actions
export default colorSlice.reducer